import { scrubValue } from "./sentry-privacy"

export function toLogRecord(data: unknown): Record<string, unknown> | undefined {
  if (data == null) return undefined

  const scrubbed = scrubValue(data)

  if (
    typeof scrubbed === "object" &&
    scrubbed !== null &&
    !Array.isArray(scrubbed)
  ) {
    return scrubbed as Record<string, unknown>
  }

  return { value: scrubbed }
}

export function formatLogData(data: unknown): string | undefined {
  const record = toLogRecord(data)
  if (!record) return undefined

  try {
    return JSON.stringify(record)
  } catch {
    return String(record)
  }
}
